var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMessage = function SvgMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m751.04 742.08-143.04-80H378.24c-58.145 0-105.28-47.135-105.28-105.28V387.2c.361-57.999 47.281-104.919 105.246-105.28H645.76c58.072.181 105.099 47.209 105.28 105.263v.017zm-372.8-431.04c-41.989.181-75.979 34.171-76.16 76.143v169.618c0 42.126 34.059 76.298 76.143 76.479H614.08l107.84 59.52V387.2c-.181-41.989-34.171-75.979-76.143-76.16h-.017z"
  })));
};
export default SvgMessage;